export default "__VITE_ASSET__1316c4a4__"